import {Box, Paper, Typography} from '@mui/material';
import {Job, JobStatus} from '@cp/model';

interface JobDetailDialogErrorsProps {
  job: Job;
}

export default function JobDetailDialogErrors({job}: JobDetailDialogErrorsProps) {
  if (job.status !== JobStatus.FAILED || !job.messages || job.messages.length === 0) {
    return null;
  }

  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom sx={{fontWeight: 600, color: 'error.main'}}>
        Error Details
      </Typography>
      <Paper sx={{p: 2, bgcolor: 'error.light', color: 'error.contrastText'}}>
        <Typography variant="body2">
          {job.messages.filter((msg) => msg.toLowerCase().includes('error')).join('\n')}
        </Typography>
      </Paper>
    </Box>
  );
}
